import { render } from "./product-upsell.vue?vue&type=template&id=5ec8f311"
import script from "./product-upsell.vue?vue&type=script&lang=js"
export * from "./product-upsell.vue?vue&type=script&lang=js"

import "./product-upsell.vue?vue&type=style&index=0&id=5ec8f311&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__